/* eslint-disable react-hooks/exhaustive-deps */
import styles from './PayModal.module.less'
import { Modal, Spin, QRCode, Typography} from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { commonUtils } from '@/helpers/commonUtils'
import classNames from 'classnames'
import { useEffect } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import { api } from '@/helpers/api'
import { payService } from '@/services/payService'
import { userService } from '@/services/userService/userService'
import { IconImage } from '@/components/Icon/Icon'

export interface PayModalProps {
  visible: boolean
  goodsDetail?: DataModels.goods.CourseMaterialDetail
  resourceId?: string
  onClose: () => void
  onPaySuccess: (goodsName: string) => void
}

const featureMap = [
  {
    title: '包含 {0} 套精编课件',
    gift: ['配套教学设计(部分科目包含)'],
    service: null,
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['教学设计（部分科目包含）', '配套音视频素材', '班会主题课件'],
    service: '专属人工客服答疑',
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['教学设计（部分科目包含）', '配套音视频素材', '班会主题课件'],
    service: '专属人工客服答疑',
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['教学设计（部分科目包含）', '配套音视频素材', '班会主题课件'],
    service: '专属人工客服答疑',
  },
]

const modalMap = {
  4: { width: 935, class: styles.four },
  3: { width: 779, class: styles.three },
  2: { width: 773, class: styles.two },
}

// 使用antd的Modal组件
const PayModal: React.FC<PayModalProps> = ({
  visible,
  onClose,
  goodsDetail,
  resourceId,
  onPaySuccess,
}) => {
  const countdownTimerRef = useRef<number | null>(null)
  const [checked, setChecked] = useState<DataModels.goods.CourseMaterialPriceInfo>(
    {} as DataModels.goods.CourseMaterialPriceInfo
  )
  const [qrCode, setQrCode] = useState('')
  const [plans, setPlans] = useState<DataModels.goods.CourseMaterialPriceInfo[]>([])
  const [createOrderIng, setCreateOrderIng] = useState(false)
  const [modalType, setModalType] = useState(modalMap[2])
  const [feature, setFeature] = useState(featureMap[0])
  const [chargeChannel, setChargeChannel] = useState<'wx_pub_qr' | 'alipay_qr'>('wx_pub_qr')
  const [currentTimestamp, setCurrentTimestamp] = useState(Date.now())
  
  // 新增优惠券相关状态
  const [coupons, setCoupons] = useState< DataModels.Coupon.UseCouponItem[]>([])
  const [selectedCoupon, setSelectedCoupon] = useState<DataModels.Coupon.UseCouponItem | null>(null)

  useEffect(() => {
    payService.stopCheckPayStatus()
    if (!goodsDetail || !visible) return
    api.goods
      .getCourseMaterialPriceInfo(goodsDetail.goodsId, goodsDetail.goodsType, resourceId)
      .then(({ data }) => {
        // const idx = Math.min(data.length - 1, 3)
        const idx =0;
        setPlans(data)
        setChecked(data[idx])
        setFeature(featureMap[idx] ?? featureMap.at(-1))
        setModalType(modalMap[Math.min(Math.max(data.length, 2), 4) as keyof typeof modalMap])
      }).catch((e) => {
        console.error(e)
      })

    userService.postUserActionRecord({
      module: 'PC端官网',
      function: '付费弹窗',
      position: '触发付费弹窗',
      action: '展示',
      element: '页面',
    })
  }, [goodsDetail, visible])

  useEffect(() => {
    if (!visible) {
      return undefined
    }

    setCurrentTimestamp(Date.now())

    countdownTimerRef.current = window.setInterval(() => {
      setCurrentTimestamp(Date.now())
    }, 1000)

    return () => {
      if (countdownTimerRef.current) {
        window.clearInterval(countdownTimerRef.current)
        countdownTimerRef.current = null
      }
    }
  }, [visible])

  const parseCurrency = (price?: number) => {
    if (typeof price === 'number') {
      return commonUtils.parseCurrency(price)
    }
    return '-'
  }

  const isSingleCourse = (item?: DataModels.goods.CourseMaterialPriceInfo) => {
    return item?.goodsType === 1
  }

  const hasLimitedPromotion = (item?: DataModels.goods.CourseMaterialPriceInfo) => {
    if (!item || !isSingleCourse(item) || !item.priceLine) {
      return false
    }

    return true
  }

  // const getDisplayPrice = (item?: DataModels.goods.CourseMaterialPriceInfo) => {
  //   if (!item) {
  //     return 0
  //   }

  //   return item.goodsPrice
  // }

  const getOriginalPrice = (item?: DataModels.goods.CourseMaterialPriceInfo) => {
    if (!item || !hasLimitedPromotion(item)) {
      return undefined
    }
    return item.priceLine
  }

  const getCountdownSeconds = (item?: DataModels.goods.CourseMaterialPriceInfo) => {
    if (!item?.promotionEndTime) {
      return 0
    }

    return Math.max(
      0,
      Math.floor((new Date(item.promotionEndTime).getTime() - currentTimestamp) / 1000)
    )


    
  }

  const formatCountdown = (totalSeconds: number) => {
    const days = Math.floor(totalSeconds / (24 * 3600))
    const hours = Math.floor(totalSeconds / 3600)
    const remainHours = Math.floor((totalSeconds % (24 * 3600)) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    if (days > 0) {
      return `${days}天${String(remainHours).padStart(2, '0')}时${String(minutes).padStart(
        2,
        '0'
      )}分${String(seconds).padStart(2, '0')}秒`
    }

    return `${String(hours).padStart(2, '0')}时${String(minutes).padStart(2, '0')}分${String(
      seconds
    ).padStart(2, '0')}秒`
  }

  // 新增：计算优惠后的价格
  const calculateFinalPrice = () => {
    const originalPrice = checked?.goodsPrice || 0
    if (selectedCoupon) {
      return Math.max(0, originalPrice - selectedCoupon.rule.reductAmount)
    }
    return originalPrice
  }

  // 新增：处理优惠券选择
  const handleCouponSelect = (coupon: DataModels.Coupon.UseCouponItem) => {
    setSelectedCoupon(coupon)
  }

  useEffect(() => {
    if (!visible || !countdownTimerRef.current || !checked?.promotionEndTime) {
      return
    }

    if (getCountdownSeconds(checked) === 0) {
      window.clearInterval(countdownTimerRef.current)
      countdownTimerRef.current = null
    }
  }, [checked, currentTimestamp, visible])

  // // 新增：移除优惠券
  // const handleRemoveCoupon = () => {
  //   setSelectedCoupon(null)
  // }

  useEffect(() => {
    // 只有在弹窗可见时才创建订单
    if (!visible) return
    
    if (plans.length > 0 && checked?.goodsId) {
      createOrder()
    }
  }, [plans, checked, chargeChannel, selectedCoupon?.id])

  useEffect(() => {
    getAvaliableCoupons()
  }, [plans, checked, chargeChannel,selectedCoupon?.id])

  const getAvaliableCoupons = async() => {
    if (!checked?.goodsId) return
    try{
      const data =  await api.order.getAvaliableCoupons(checked.goodsId)
      setCoupons(data.data.list)
    }catch(e){
      console.log('获取优惠券失败', e)
    }
  }

  const createOrder = async () => {
    setCreateOrderIng(true)
    try{
       await payService.createPayQrCode({
      goodsId: checked?.goodsId,
      goodsType: checked?.goodsType,
      userCouponId:selectedCoupon?.id,
      chargeChannel,
      cb: (codeUrl: string) => {
        setQrCode(codeUrl)
        setCreateOrderIng(false)
      },
      onPaySuccess: () => {
        onPaySuccess(checked?.goodsName)
        onClose()
      },
    })
    }catch(e){
     console.log('创建订单失败', e)
    }
  }

  const handlePlanChange = (item: DataModels.goods.CourseMaterialPriceInfo, idx: number) => {
    setChecked(item)
    setFeature(featureMap[idx] ?? featureMap.at(-1))
    setSelectedCoupon(null)
  }

  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      closeIcon={<CloseOutlined />}
      onCancel={()=>{
        selectedCoupon && setSelectedCoupon(null)
        onClose()
      }}
      width={modalType.width}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 28,
        },
      }}
    >
      <div className={styles.payModal} style={{ width: modalType.width }}>
        <div className={styles.leftPanel}>
          <img
            className={styles.leftPanelBg}
            src={commonUtils.getStaticFile('pc/pay/bg__left.png')}
            alt='一起课件'
          />
          <div className={styles.logo}>
            <img src={commonUtils.getStaticFile('logo-new.png')} alt='一起课件' />
          </div>
          <img
            className={styles.icon1}
            src={commonUtils.getStaticFile('pc/pay/icon__lingxing.png')}
            alt='一起课件'
          />
          <img
            className={styles.icon2}
            src={commonUtils.getStaticFile('pc/pay/icon__lingxing.png')}
            alt='一起课件'
          />
          <img
            className={styles.icon3}
            src={commonUtils.getStaticFile('pc/pay/icon__path.png')}
            alt='pc/pay/icon__path'
          />
          <div className={styles.leftPanelSlogen}>专注专业教学课件研发</div>
          <div className={styles.features}>
            <div className={styles.featuresTitle}>会员权益</div>
            <div className={styles.featuresContent}>
              <div
                className={styles.featuresContentItem}
                dangerouslySetInnerHTML={{
                  __html: commonUtils.stringFormat(
                    feature.title,
                    `<span style="color: #FF7307; font-weight: bold">${
                      checked?.couresCount ?? 1
                    }</span>`
                  ),
                }}
              />
              <div className={classNames(styles.featuresContentItem, styles.gift)}>
                <div className={styles.listTitle}>赠送：</div>
                <div className={styles.list}>
                  {feature.gift.map((item) => (
                    <div key={item} className={styles.listItem}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              {feature.service && (
                <div className={styles.featuresContentItem}>{feature.service}</div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div className={styles.title}>升级会员</div>
          <div className={classNames(styles.orderPlan, modalType.class)}>
            {plans.map((item, index) => (
              <div
                key={item.goodsId}
                className={classNames(styles.orderPlanItem, {
                  [styles.active]: checked?.goodsId === item.goodsId,
                })}
                onClick={() => handlePlanChange(item, index)}
              >
                <div className={styles.orderPlanItemTitle}>
                  {index === 0 ? '单课件' : item.goodsName}
                </div>
                {hasLimitedPromotion(item) ? (
                  <>
                   <span className={styles.limitedTag}>限时价</span>
                  <div className={styles.orderPlanItemLimitedPrice}>
                    <div>
                      <span className={styles.currentPrice}>
                       <b>¥</b> {parseCurrency(item?.goodsPrice)}
                      </span>
                    </div>
                    
                    <span className={styles.originPrice}>
                      原价 ¥{parseCurrency(getOriginalPrice(item))}
                    </span>
                    <span className={styles.countdownText}>
                      {getCountdownSeconds(item) > 0
                        ? `距结束${formatCountdown(getCountdownSeconds(item))}`
                        : '已结束'}
                    </span>
                  </div>
                  </>
                ) : (
                  <div className={styles.orderPlanItemPrice}>
                    <span>¥</span> {parseCurrency(item?.goodsPrice)}
                  </div>
                )}

                {item?.onePrice && (
                  <div className={styles.orderPlanItemOnePrice}>
                    单课件仅需 <span> {parseCurrency(item?.onePrice)}</span> 元
                  </div>
                )}

                {index === plans.length - 1 && (
                  <img
                    className={styles.recommend}
                    src={commonUtils.getStaticFile('pc/pay/icon__recommend.png')}
                    alt='一起课件'
                  />
                )}
              </div>
            ))}
          </div>
           {/* 优惠券模块 - 电商卡片形式 */}
          {coupons.length > 0 && (
            <div className={styles.couponSection}>
              <div className={styles.couponHeader}>
                <span className={styles.couponLabel}>优惠券</span>
                <span className={styles.couponCount}>({coupons.length}张可用)</span>
              </div>
              
              <div className={styles.couponList}>
              
                
                {/* 优惠券选项 */}
                {coupons.map(coupon => (
                  <div
                    key={coupon.id}
                    className={classNames(styles.couponItem, {
                      [styles.couponItemSelected]: selectedCoupon?.id === coupon.id,
                    })}
                    onClick={() => handleCouponSelect(coupon)}
                  >
                    {/* <div className={styles.couponIconWrapper}>
                      <img 
                        src={coupon.icon || commonUtils.getStaticFile('pc/pay/icon__coupon.png')} 
                        alt={coupon.name} 
                        className={styles.couponItemIcon}
                      />
                    </div> */}
                    <div className={styles.couponContent}>
                      <div className={styles.couponItemName}>{coupon.name}</div>
                      <div className={styles.couponItemCondition}>{coupon.type}</div>
                       <div className={styles.couponAmount}>
                      <span className={styles.amountLabel}>减</span>
                      <span className={styles.amountValue}>¥{parseCurrency(coupon.rule.reductAmount)}</span>
                    </div>
                    </div>
                   
                    <div className={styles.couponRadio}>
                      {selectedCoupon?.id === coupon.id && <div className={styles.radioDot} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className={styles.title}>会员支付</div>
          <div className={styles.orderPay}>
            <div className={styles.orderQrCode}>
              <Spin spinning={createOrderIng} size='small'>
                <QRCode
                  status={createOrderIng ? 'loading' : 'active'}
                  value={qrCode}
                  size={147}
                  bordered={false}
                  style={{
                    padding: 6,
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #EEEEEE',
                  }}
                ></QRCode>
              </Spin>
            </div>
            <div className={styles.orderInfo}>
                <div className={classNames(styles.orderInfoItem)}>
                  <div className={styles.label}>支付：</div>
                  <div className={styles.payType}>
                    <div
                      className={classNames(styles.payTypeItem, {
                        [styles.active]: chargeChannel === 'wx_pub_qr',
                      })}
                      onClick={() =>{
                         setChargeChannel('wx_pub_qr')
                         setSelectedCoupon(null)
                      }}
                    >
                      <IconImage width={17} height={17} src='IconWepay_1'></IconImage>
                      微信支付
                    </div>
                    <div
                      className={classNames(styles.payTypeItem, {
                        [styles.active]: chargeChannel === 'alipay_qr',
                      })}
                      onClick={() => {setChargeChannel('alipay_qr'); setSelectedCoupon(null)}}
                    >
                      <IconImage width={17} height={17} src='IconAlipay_1'></IconImage>
                      支付宝支付
                    </div>
                  </div>
                </div>

              <div className={classNames(styles.orderInfoItem, styles.content)}>
                <div className={styles.label}>内容：</div>
                <div className={styles.value}>
                  <Typography.Text
                    ellipsis={{
                      tooltip: {
                        title: checked?.goodsName,
                        classNames: {
                          root: 'pc-custom-tooltip',
                        },
                      },
                    }}
                  >
                    {checked?.goodsName}
                  </Typography.Text>
                </div>
              </div>
              <div className={classNames(styles.orderInfoItem, styles.price)}>
                <div className={styles.label}>应付：</div>
                <div className={styles.value}>
                  <span className={styles.finalPrice}>¥{parseCurrency(calculateFinalPrice())}</span>
                  {getOriginalPrice(checked) && (
                    <span className={styles.originalPrice}>
                      原价¥{parseCurrency(getOriginalPrice(checked))}
                    </span>
                  )}
                  {selectedCoupon  &&checked.goodsType!==1&& (
                    <>
                     <span className={styles.originalPrice}>¥{parseCurrency(checked?.goodsPrice)}</span>
                      <span className={styles.saveTag}>省¥{parseCurrency(selectedCoupon.rule.reductAmount)}
                    </span>
                    </>
                  )}
                </div>
              </div>
              <p className={styles.buyTips}>
                <img src={commonUtils.getStaticFile('pc/pay/icon__tips.png')} alt='一起课件' />
                开通后请在一年内及时下载，可提供发票
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PayModal
